<template>
  <div class="basic_wrap">
    <div class="page_header">
      <div class="header_inner">
        <div class="back_left" @click="$router.back()"></div>
        <div class="big_tit">购买订单</div>
      </div>
    </div>
    <div class="content_box">
      <!-- <div class="page_intro">
        <p class="intro_title">我的购买记录</p>
        <p class="intro_desc">可查看订单状态、商品信息与下单时间</p>
      </div> -->
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length === 0 ? '' : '没有更多了'"
          @load="onLoad"
        >
          <van-empty v-if="!loading && list.length === 0" description="暂无购买订单" />
          <div class="order_card" v-for="item in list" :key="item.id" @click="$router.push('/shopOrderDetail/' + item.id)">
            <div class="order_header">
              <div class="shop_meta">
                <img v-if="item.merchant_logo" :src="item.merchant_logo" alt="" class="shop_logo" />
                <div v-else class="shop_logo placeholder"></div>
                <div class="shop_text">
                  <p class="shop_name">{{ item.merchant_name || '平台自营' }}</p>
                  <p class="order_no">订单号: {{ item.order_no }}</p>
                </div>
              </div>
              <span class="status_tag" :class="statusClass(item)">{{ item.status_text }}</span>
            </div>
            <div class="item_info">
              <img :src="item.item_img" alt="" class="item_img" />
              <div class="item_detail">
                <p class="item_title van-multi-ellipsis--l2">{{ item.item_title }}</p>
                <div class="price_row">
                  <p class="item_price numberFont"><span>¥</span>{{ formatPrice(item.price) }}</p>
                  <p class="item_qty">×{{ item.quantity }}</p>
                </div>
              </div>
            </div>
            <div class="card_bottom">
              <p class="total_label">合计</p>
              <p class="total_amount numberFont"><span>¥</span>{{ formatPrice(item.total_amount) }}</p>
              <p class="create_time">{{ item.create_time }}</p>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { List, PullRefresh, Empty } from 'vant';

Vue.use(List).use(PullRefresh).use(Empty);

export default {
  name: "shopOrders",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  methods: {
    formatPrice(price) {
      var num = parseFloat(price) || 0;
      return num.toFixed(2);
    },
    statusClass(item) {
      var status = parseInt(item.status);
      if (status === 3) return 'status_done';
      if (status === 4) return 'status_fail';
      if (status === 2) {
        // 卡券发放失败（已退款）显示为"已失败"
        if (parseInt(item.goods_type) === 1 && item.card_status === '已退款') return 'status_fail';
        return 'status_cancel';
      }
      if (status === 1) return 'status_wait';
      return 'status_pending';
    },
    onLoad() {
      Fetch('/shop/orders', {
        page: this.page,
        page_size: 10
      }).then((r) => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        var res = r.data;
        this.list = this.list.concat(res.list || []);
        this.loading = false;
        if ((res.list || []).length < 10) {
          this.finished = true;
        } else {
          this.page++;
        }
      }).catch(() => {
        this.loading = false;
        this.refreshing = false;
      });
    },
    onRefresh() {
      this.finished = false;
      this.page = 1;
      this.loading = true;
      this.onLoad();
    }
  },
};
</script>

<style lang="less" scoped>
.basic_wrap {
  padding-top: 60px;
  min-height: 100vh;
  background: #F6F7FB;
}
.page_header {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  z-index: 20;
  background: url(../../assets/images/red_bg.png) no-repeat center center;
  background-size: 100% 100%;
}
.header_inner {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back_left {
  position: absolute;
  left: 0;
  top: 14px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: url(../images/item/back.png) no-repeat center center;
  background-size: auto 100%;
}
.big_tit {
  font-size: 17px;
  font-weight: 600;
  color: #FFFFFF;
}
.content_box {
  padding: 12px 12px 16px 12px;
}
.page_intro {
  background: linear-gradient(135deg, #FFF2EC 0%, #FFFFFF 100%);
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 12px;
  .intro_title {
    font-size: 15px;
    font-weight: 600;
    color: #1F2329;
  }
  .intro_desc {
    margin-top: 4px;
    font-size: 12px;
    color: rgba(31,35,41,.6);
  }
}
.order_card {
  width: 100%;
  background: #FFFFFF;
  border-radius: 14px;
  padding: 14px 14px 12px 14px;
  margin-bottom: 12px;
  box-shadow: 0px 4px 18px rgba(31, 35, 41, 0.08);
}
.order_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  .shop_meta {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
  }
  .shop_logo {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #F2F3F5;
    object-fit: cover;
    flex-shrink: 0;
    &.placeholder {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        inset: 11px;
        border-radius: 50%;
        background: #D9DBE1;
      }
    }
  }
  .shop_text {
    min-width: 0;
    margin-left: 10px;
  }
  .shop_name {
    font-size: 14px;
    font-weight: 600;
    color: #1F2329;
  }
  .order_no {
    font-size: 12px;
    color: rgba(31,35,41,.5);
    margin-top: 3px;
  }
  .status_tag {
    font-size: 11px;
    padding: 4px 10px;
    border-radius: 999px;
    border: 1px solid transparent;
    margin-left: 10px;
    flex-shrink: 0;
  }
  .status_wait {
    color: #FF6A3D;
    background: rgba(255, 106, 61, 0.12);
    border-color: rgba(255, 106, 61, 0.25);
  }
  .status_done {
    color: #07C160;
    background: rgba(7, 193, 96, 0.12);
    border-color: rgba(7, 193, 96, 0.25);
  }
  .status_cancel {
    color: #909399;
    background: rgba(144, 147, 153, 0.12);
    border-color: rgba(144, 147, 153, 0.25);
  }
  .status_fail {
    color: #E3382E;
    background: rgba(227, 56, 46, 0.12);
    border-color: rgba(227, 56, 46, 0.25);
  }
  .status_pending {
    color: #3D96FF;
    background: rgba(61, 150, 255, 0.12);
    border-color: rgba(61, 150, 255, 0.25);
  }
}
.item_info {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  background: #F8F9FC;
  border-radius: 12px;
  padding: 10px;
  .item_img {
    width: 76px;
    height: 76px;
    border-radius: 10px;
    flex-shrink: 0;
    object-fit: cover;
  }
  .item_detail {
    flex: 1;
    margin-left: 12px;
    .item_title {
      font-size: 14px;
      line-height: 20px;
      color: #1F2329;
      min-height: 40px;
    }
    .price_row {
      display: flex;
      align-items: baseline;
      margin-top: 8px;
      .item_price {
        font-size: 16px;
        color: #E3382E;
        font-weight: 600;
        span {
          font-size: 11px;
        }
      }
      .item_qty {
        font-size: 12px;
        color: rgba(0,0,0,.6);
        margin-left: 6px;
      }
    }
  }
}
.card_bottom {
  display: flex;
  align-items: center;
  padding-top: 2px;
  .total_label {
    font-size: 12px;
    color: rgba(31,35,41,.6);
  }
  .total_amount {
    font-size: 15px;
    color: #E3382E;
    font-weight: bold;
    margin-left: 6px;
    span {
      font-size: 12px;
    }
  }
  .create_time {
    font-size: 11px;
    color: rgba(31,35,41,.4);
    margin-left: auto;
  }
}
</style>
